export const siteName = '亲亲漫画';

export const headerNav = [
  { label: '热门话题', href: '#topics' },
  { label: '精选推荐', href: '#cards' },
  { label: '视频专区', href: '#media' },
  { label: '焦点专题', href: '#carousel' },
];

export const heroData = {
  tagline: '韩漫 · 日漫 · 国漫 一站在手',
  h1: '亲亲漫画 — 免费高清漫画在线阅读与下载平台',
  slogan: '随时随地，畅享下拉式阅读新体验',
  description: [
    '亲亲漫画是国内领先的免费漫画阅读平台，汇集海量韩漫、日漫、国漫资源，涵盖恋爱、奇幻、悬疑、热血等全品类题材，每日同步更新最新话。无论是热门连载还是完结经典，你都能在这里找到。',
    '支持安卓APP、iOS手机版下载安装，提供下拉式在线阅读与离线缓存功能，免去网络限制，追更不间断。高清画质、流畅翻页，为你打造沉浸式移动阅读体验。',
  ],
  stats: [
    { value: '30000+', label: '漫画资源' },
    { value: '每日更新', label: '同步连载' },
    { value: '5000万+', label: '累计用户' },
  ],
  primaryCta: { label: '立即下载APP', href: '#app' },
  secondaryCta: { label: '浏览热门漫画', href: '#ranking' },
};

export const topicsData = [
  { tag: '韩漫推荐', heat: '128.5万', href: '#cards' },
  { tag: '连载追踪', heat: '96.3万', href: '#updates' },
  { tag: '恋爱漫画', heat: '87.2万', href: '#cards' },
  { tag: '奇幻冒险', heat: '75.8万', href: '#cards' },
  { tag: '日漫经典', heat: '69.4万', href: '#carousel' },
  { tag: '国漫崛起', heat: '62.1万', href: '#cards' },
  { tag: '悬疑推理', heat: '54.7万', href: '#cards' },
  { tag: '热血格斗', heat: '48.3万', href: '#cards' },
  { tag: '搞笑日常', heat: '42.6万', href: '#cards' },
  { tag: '完结神作', heat: '38.9万', href: '#index' },
];

export const featuresData = [
  {
    icon: 'ri-smartphone-line',
    title: '下拉式阅读',
    desc: '独创竖屏下拉模式，单手操作无缝翻页，还原纸质漫画阅读节奏，沉浸感拉满。',
  },
  {
    icon: 'ri-download-cloud-2-line',
    title: '离线缓存',
    desc: 'WiFi环境下批量缓存，无网络也能畅快追更，地铁通勤、旅途出行首选。',
  },
  {
    icon: 'ri-hd-line',
    title: '超清画质',
    desc: '原版高清扫描，支持画质增强模式，细节纤毫毕现，每一格都是壁纸级别。',
  },
  {
    icon: 'ri-global-line',
    title: '海量正版',
    desc: '收录30000+部漫画作品，涵盖韩漫、日漫、国漫全品类，持续扩充中。',
  },
  {
    icon: 'ri-timer-flash-line',
    title: '极速更新',
    desc: '热门连载每日同步更新，第一时间推送提醒，追更快人一步，永不错过。',
  },
];

export const rankingData = [
  { rank: 1, title: '我独自升级', chapter: '已完结', reads: '1.2亿', tag: '韩漫' },
  { rank: 2, title: '剑尊归来', chapter: '连载至218话', reads: '9800万', tag: '韩漫' },
  { rank: 3, title: '全知读者视角', chapter: '连载至186话', reads: '8700万', tag: '韩漫' },
  { rank: 4, title: '一击男', chapter: '连载至252话', reads: '7600万', tag: '日漫' },
  { rank: 5, title: '斗破苍穹', chapter: '连载至568话', reads: '6500万', tag: '国漫' },
];

export const cardsData = [
  {
    title: '恶女的定义',
    tag: '韩漫·恋爱',
    desc: '重生为恶女配角的她，决心改写命运，却意外卷入了宫廷权谋的漩涡。精致的画风与跌宕的剧情，让这部作品成为近期韩漫口碑之作。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20style%20cover%20art%2C%20elegant%20female%20character%20in%20historical%20dress%2C%20soft%20warm%20lighting%2C%20detailed%20illustration%20with%20decorative%20floral%20elements%2C%20clean%20minimal%20background%2C%20manga%20cover%20aesthetic%2C%20high%20quality%20digital%20art&width=640&height=900&seq=manga-card-01&orientation=portrait',
  },
  {
    title: '全知读者视角',
    tag: '韩漫·奇幻',
    desc: '某天世界变成了他读过的小说，作为唯一知晓剧情的人，他必须在末日降临前集结同伴。世界观宏大、角色塑造丰满，人气常年霸榜。',
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20action%20manhwa%20cover%20art%2C%20male%20protagonist%20with%20determined%20expression%2C%20dramatic%20lighting%20with%20warm%20golden%20tones%2C%20epic%20atmosphere%2C%20clean%20focused%20composition%2C%20manga%20cover%20style%2C%20high%20quality%20digital%20illustration&width=640&height=900&seq=manga-card-02&orientation=portrait',
  },
  {
    title: 'SSS级重生猎人',
    tag: '韩漫·热血',
    desc: '人类最强者在最终决战中倒下，却带着记忆回到二十年前。带着前世所有战斗经验，这一次他要改写所有人的命运。酣畅淋漓的战斗分镜是最大看点。',
    image: 'https://readdy.ai/api/search-image?query=Action%20manhwa%20cover%2C%20powerful%20hunter%20character%20with%20glowing%20aura%2C%20dynamic%20pose%2C%20warm%20orange%20and%20red%20energy%20effects%2C%20dramatic%20composition%2C%20minimal%20dark%20background%2C%20high%20quality%20digital%20art%20cover%20style&width=640&height=900&seq=manga-card-03&orientation=portrait',
  },
  {
    title: '咒术回战',
    tag: '日漫·战斗',
    desc: '高中生虎杖悠仁吞下诅咒手指后，踏入了咒术师的世界。与伙伴们一起对抗诅咒，激烈打斗与深刻羁绊交织的少年漫标杆之作。',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20shonen%20manga%20cover%20art%2C%20young%20male%20character%20with%20confident%20smile%2C%20dynamic%20action%20pose%2C%20warm%20vibrant%20color%20palette%2C%20bold%20graphic%20style%2C%20minimal%20gradient%20background%2C%20high%20quality%20illustration&width=640&height=900&seq=manga-card-04&orientation=portrait',
  },
  {
    title: '镖人',
    tag: '国漫·武侠',
    desc: '大漠刀客刀马的传奇江湖故事，硬派写实画风与酣畅淋漓的刀光剑影，被誉为国漫之光。许先哲用画笔描绘了一个充满侠义与血性的西部世界。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20wuxia%20manhua%20cover%20art%2C%20lone%20swordsman%20in%20desert%20landscape%2C%20dramatic%20wind%20effects%2C%20warm%20earthy%20color%20tones%2C%20ink%20brush%20style%2C%20bold%20composition%2C%20high%20quality%20digital%20illustration&width=640&height=900&seq=manga-card-05&orientation=portrait',
  },
  {
    title: '某天成为公主',
    tag: '韩漫·穿越',
    desc: '穿越成为童话故事里的公主，却发现自己注定迎来悲惨结局。为了活下去，她开始改写故事，与冷酷父皇之间催泪又温暖的父女线打动无数读者。',
    image: 'https://readdy.ai/api/search-image?query=Romance%20fantasy%20manhwa%20cover%2C%20beautiful%20princess%20character%20in%20elegant%20gown%2C%20soft%20pastel%20warm%20lighting%2C%20castle%20interior%20blurred%20background%2C%20delicate%20illustration%20style%2C%20high%20quality%20digital%20art&width=640&height=900&seq=manga-card-06&orientation=portrait',
  },
  {
    title: '一人之下',
    tag: '国漫·异能',
    desc: '普通大学生张楚岚因爷爷的坟墓被盗，卷入异人世界的纷争。道家文化、现代都市与超能力战斗的完美融合，米二的封神之作。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20supernatural%20manhua%20cover%2C%20young%20male%20character%20with%20mysterious%20energy%20surrounding%2C%20urban%20night%20atmosphere%2C%20warm%20golden%20glow%20effects%2C%20modern%20manga%20style%2C%20clean%20hero%20composition%2C%20high%20quality%20digital%20illustration&width=640&height=900&seq=manga-card-07&orientation=portrait',
  },
];

export const mediaData = [
  {
    title: '2024韩漫年度盘点：不可错过的十部神作',
    duration: '12:38',
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20video%20thumbnail%20style%2C%20collage%20of%20popular%20manga%20covers%20with%20warm%20lighting%2C%20play%20button%20overlay%2C%20clean%20modern%20design%2C%20vibrant%20colors%2C%20youtube%20thumbnail%20aesthetic&width=800&height=450&seq=media-thumb-01&orientation=landscape',
  },
  {
    title: '《我独自升级》动画化PV首发解析',
    duration: '08:15',
    image: 'https://readdy.ai/api/search-image?query=Anime%20trailer%20thumbnail%20style%2C%20solo%20leveling%20inspired%20action%20scene%2C%20dark%20knight%20character%20with%20purple%20energy%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20warm%20accent%20colors&width=800&height=450&seq=media-thumb-02&orientation=landscape',
  },
  {
    title: '从零开始的漫画创作：国漫作者访谈纪实',
    duration: '22:47',
    image: 'https://readdy.ai/api/search-image?query=Artist%20studio%20workspace%20with%20drawing%20tablet%20and%20sketches%2C%20warm%20ambient%20lighting%2C%20creative%20atmosphere%2C%20documentary%20interview%20style%2C%20cozy%20interior%2C%20professional%20setup&width=800&height=450&seq=media-thumb-03&orientation=landscape',
  },
  {
    title: '画风炸裂！2024上半年新连载推荐',
    duration: '15:20',
    image: 'https://readdy.ai/api/search-image?query=Manga%20recommendation%20video%20thumbnail%2C%20grid%20of%20colorful%20manga%20pages%2C%20warm%20vibrant%20art%20style%2C%20rating%20stars%20overlay%2C%20clean%20graphic%20design%2C%20youtube%20thumbnail%20layout&width=800&height=450&seq=media-thumb-04&orientation=landscape',
  },
];

export const commentsData = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20female%20profile%20avatar%2C%20young%20woman%20with%20warm%20smile%2C%20clean%20light%20background%2C%20soft%20natural%20lighting%2C%20professional%20headshot%20style&width=80&height=80&seq=avatar-01&orientation=squarish',
    name: '漫画少女小鹿',
    date: '2024-07-25',
    rating: 5,
    content: '用了亲亲漫画两年了，画质真的没话说，离线缓存功能太适合我这种地铁通勤党了。韩漫更新速度也很快，基本和韩网同步，五星推荐！',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20male%20profile%20avatar%2C%20casual%20style%2C%20friendly%20expression%2C%20clean%20white%20background%2C%20soft%20portrait%20lighting%2C%20professional%20headshot&width=80&height=80&seq=avatar-02&orientation=squarish',
    name: '追漫十年的阿杰',
    date: '2024-07-23',
    rating: 5,
    content: '从大学开始看漫画到现在工作，用过很多App，最后只留了亲亲漫画。下拉式阅读真的很舒服，界面也干净没广告干扰，良心软件。',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20female%20anime%20style%20profile%20avatar%2C%20young%20girl%20with%20glasses%2C%20warm%20gentle%20expression%2C%20clean%20pastel%20background%2C%20soft%20lighting%2C%20illustration%20style&width=80&height=80&seq=avatar-03&orientation=squarish',
    name: '二次元小透明',
    date: '2024-07-20',
    rating: 4,
    content: '国漫资源越来越多了，镖人和一人之下都能在亲亲漫画上看，真的很惊喜。希望能再多加点国漫新作，支持国产漫画崛起！',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Mature%20Asian%20male%20profile%20portrait%2C%20professional%20appearance%2C%20confident%20look%2C%20clean%20minimal%20background%2C%20warm%20studio%20lighting%2C%20headshot%20style&width=80&height=80&seq=avatar-04&orientation=squarish',
    name: '深夜追更人',
    date: '2024-07-18',
    rating: 5,
    content: '更新推送很及时，每天晚上十点准时收到更新提醒，再也不用自己刷了。离线缓存一次性下几十话，出差飞机上也能看，太方便了。',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Fashionable%20young%20Asian%20woman%20profile%20portrait%2C%20trendy%20style%2C%20warm%20friendly%20smile%2C%20clean%20light%20background%2C%20soft%20natural%20lighting%2C%20modern%20headshot&width=80&height=80&seq=avatar-05&orientation=squarish',
    name: '漫画安利官小野',
    date: '2024-07-15',
    rating: 5,
    content: '被朋友安利来的，下载后就停不下来了！分类很全，找漫画特别方便。下拉式翻页体验比传统翻页好太多了，已经推荐给整个办公室的同事了。',
  },
];

export const contactData = {
  title: '联系我们',
  desc: '商务合作、版权洽谈、内容投稿，欢迎通过以下方式联系亲亲漫画团队。我们珍视每一位合作伙伴与读者的反馈。',
  email: 'contact@qinqinmanga.com',
  wechat: 'qinqinmanga_official',
  items: [
    { icon: 'ri-mail-line', label: '商务合作邮箱', value: 'business@qinqinmanga.com' },
    { icon: 'ri-edit-2-line', label: '内容投稿邮箱', value: 'submit@qinqinmanga.com' },
    { icon: 'ri-wechat-line', label: '官方微信公众号', value: '亲亲漫画' },
    { icon: 'ri-customer-service-2-line', label: '客服工作时间', value: '周一至周日 9:00-22:00' },
  ],
};

export const appData = {
  title: '下载亲亲漫画APP',
  desc: '支持安卓与iOS双平台，扫描二维码或在应用商店搜索"亲亲漫画"即可下载。',
  platforms: [
    { icon: 'ri-android-line', name: 'Android 版', desc: '支持 Android 7.0 及以上', qrLabel: '安卓扫码下载' },
    { icon: 'ri-apple-line', name: 'iOS 版', desc: '支持 iOS 14.0 及以上', qrLabel: 'iOS扫码下载' },
  ],
  features: ['下拉式阅读', '离线缓存', '更新推送', '高清画质', '夜间模式', '书签同步'],
};

export const carouselData = [
  {
    title: '韩漫崛起：从网络漫画到全球文化现象',
    desc: '深度解析韩国网络漫画产业的发展历程，从Naver Webtoon到KakaoPage，韩漫如何用十年时间征服全球读者。',
    tag: '深度专题',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20culture%20feature%20banner%2C%20colorful%20manhwa%20illustration%20collage%2C%20warm%20vibrant%20atmosphere%2C%20modern%20digital%20art%20display%2C%20cultural%20exhibition%20style%2C%20rich%20visual%20composition&width=1000&height=560&seq=carousel-01&orientation=landscape',
  },
  {
    title: '2024夏季新番导览：必追连载一网打尽',
    desc: '炎炎夏日，窝在空调房里看漫画是最幸福的时光。我们为你整理了本季最值得追的15部新连载，涵盖恋爱、奇幻、悬疑等多种类型。',
    tag: '新番推荐',
    image: 'https://readdy.ai/api/search-image?query=Summer%20manga%20collection%20banner%2C%20vibrant%20colorful%20manga%20covers%20arrangement%2C%20warm%20sunny%20atmosphere%2C%20clean%20modern%20layout%2C%20summer%20themed%20illustration%2C%20refreshing%20visual%20style&width=1000&height=560&seq=carousel-02&orientation=landscape',
  },
  {
    title: '国漫风云录：从《镖人》到《一人之下》',
    desc: '近年来国漫佳作频出，从硬派武侠到都市异能，中国漫画家们正在用画笔讲述属于这个时代的故事。回顾那些令人热血沸腾的国漫名作。',
    tag: '国漫专题',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20feature%20banner%2C%20ink%20wash%20painting%20style%20with%20warm%20earthy%20tones%2C%20traditional%20Chinese%20aesthetic%20blended%20with%20modern%20illustration%2C%20dramatic%20composition%2C%20cultural%20heritage%20atmosphere&width=1000&height=560&seq=carousel-03&orientation=landscape',
  },
  {
    title: '漫画改编动画：那些从纸面走向荧幕的神作',
    desc: '《我独自升级》《咒术回战》《间谍过家家》……越来越多的漫画被改编为动画。我们盘点了那些动画化后口碑爆炸的原作漫画。',
    tag: '动画改编',
    image: 'https://readdy.ai/api/search-image?query=Anime%20adaptation%20feature%20banner%2C%20manga%20to%20anime%20transition%20visual%2C%20split%20screen%20style%20comparing%20original%20and%20animated%2C%20warm%20cinematic%20lighting%2C%20dramatic%20atmosphere%2C%20rich%20composition&width=1000&height=560&seq=carousel-04&orientation=landscape',
  },
  {
    title: '漫画家生存图鉴：光环背后的创作日常',
    desc: '一周画70小时、赶稿到凌晨、咖啡续命……我们走近几位漫画作者，记录他们光环背后的真实创作生活，以及坚持梦想的力量。',
    tag: '创作者故事',
    image: 'https://readdy.ai/api/search-image?query=Manga%20artist%20workspace%20behind%20the%20scenes%2C%20drawing%20desk%20with%20sketches%20and%20tools%2C%20warm%20late%20night%20studio%20lighting%2C%20creative%20atmosphere%2C%20intimate%20documentary%20style%2C%20cozy%20productive%20vibe&width=1000&height=560&seq=carousel-05&orientation=landscape',
  },
  {
    title: '漫画分类指南：找到属于你的那一部',
    desc: '恋爱、热血、奇幻、悬疑、搞笑、恐怖……漫画类型多到眼花？这份分类指南帮你快速定位最适合你口味的作品类型。',
    tag: '新手入门',
    image: 'https://readdy.ai/api/search-image?query=Manga%20genre%20guide%20visual%2C%20colorful%20category%20icons%20arrangement%2C%20warm%20inviting%20atmosphere%2C%20clean%20educational%20infographic%20style%2C%20friendly%20beginner%20oriented%20design%2C%20vibrant%20illustration&width=1000&height=560&seq=carousel-06&orientation=landscape',
  },
];

export const aboutData = {
  title: '关于亲亲漫画',
  paragraphs: [
    '亲亲漫画成立于2018年，是国内领先的免费漫画在线阅读平台。我们致力于为漫画爱好者提供海量高清漫画资源和极致的移动阅读体验，目前平台收录超过30000部漫画作品，涵盖韩漫、日漫、国漫等全品类内容，累计服务超过5000万用户。',
    '平台采用自主研发的下拉式阅读引擎，支持竖屏单手操作与智能预加载技术，让漫画阅读更加流畅自然。同时提供离线缓存、更新推送、夜间模式等实用功能，满足用户在不同场景下的阅读需求。我们与国内外多家漫画平台和出版社建立了深度合作关系，持续引进优质正版内容。',
  ],
  stats: [
    { value: '30000+', label: '漫画资源' },
    { value: '5000万+', label: '累计用户' },
    { value: '99.9%', label: '服务可用率' },
    { value: '每日更新', label: '连载同步' },
  ],
};

export const indexData = [
  { category: '韩漫·恋爱', count: 1280, href: '#cards' },
  { category: '韩漫·奇幻', count: 960, href: '#cards' },
  { category: '韩漫·热血', count: 850, href: '#cards' },
  { category: '日漫·少年', count: 2100, href: '#cards' },
  { category: '日漫·青年', count: 1560, href: '#cards' },
  { category: '国漫·武侠', count: 680, href: '#cards' },
  { category: '国漫·都市', count: 920, href: '#cards' },
];

export const updatesData = [
  { date: '2024.07.28', title: '《剑尊归来》第219话更新', desc: '陈武玄重返华山派，与昔日同门的对决一触即发。' },
  { date: '2024.07.28', title: '《全知读者视角》第187话更新', desc: '金独子面对第十个场景的最终BOSS，队友集结。' },
  { date: '2024.07.27', title: '《我独自升级》番外篇上线', desc: '番外特别篇：那些不为人知的S级猎人日常故事。' },
  { date: '2024.07.27', title: '亲亲漫画App v5.8.0版本更新', desc: '新增AI智能推荐引擎，优化离线缓存速度，修复已知问题。' },
  { date: '2024.07.26', title: '《恶女的定义》第86话更新', desc: '真相浮出水面，原来一切都在她的计划之中。' },
  { date: '2024.07.26', title: '暑期特别活动：限时免费阅读', desc: '精选100部完结漫画，限时免费开放全本阅读，不容错过。' },
  { date: '2024.07.25', title: '新作《末世图书馆》正式上架', desc: '末日废土中唯一的图书馆管理员，用书籍点亮幸存者的希望。' },
];

export const faqData = [
  {
    q: '亲亲漫画APP如何下载安装？',
    a: '您可以在本页面底部找到下载区域，选择安卓版或iOS版进行下载。安卓用户也可在各大应用商店搜索"亲亲漫画"下载，iOS用户在App Store搜索即可。安装后注册账号即可开始免费阅读。',
  },
  {
    q: '亲亲漫画完全免费吗？有没有隐藏收费？',
    a: '亲亲漫画提供海量免费漫画资源，绝大多数作品均可免费阅读。部分独家签约作品可能包含付费章节，但平台会在显著位置明确标注，不存在任何隐藏收费。您可以在免费区畅享上万部漫画。',
  },
  {
    q: '离线缓存功能如何使用？',
    a: '在WiFi环境下打开任意漫画详情页，点击"离线缓存"按钮即可将章节下载到本地。缓存的漫画会存储在APP内部空间中，没有网络时依然可以流畅阅读。建议定期清理已读完的缓存以释放手机存储空间。',
  },
  {
    q: '漫画更新频率是怎样的？',
    a: '热门连载漫画通常每周更新1-3话，与韩国、日本原作同步。您可以在APP中开启更新推送通知，第一时间收到最新章节上架提醒。部分作品因版权方排期不同，更新频率可能有所差异。',
  },
  {
    q: '遇到阅读问题或内容错误如何反馈？',
    a: '您可以通过APP内的"意见反馈"功能提交问题，或发送邮件至我们的客服邮箱。我们的技术团队会在24小时内处理您的问题。对于内容错误（如缺页、乱码等），我们会优先安排修复并给予反馈奖励。',
  },
];

export const footerData = {
  description: '亲亲漫画是国内领先的免费漫画在线阅读平台，提供韩漫、日漫、国漫等全品类高清漫画资源，支持安卓与iOS双平台下载，致力于为用户打造极致的下拉式移动阅读体验。',
  sections: [
    {
      title: '快速导航',
      links: [
        { label: '热门话题', href: '#topics' },
        { label: '热门榜单', href: '#ranking' },
        { label: '精选推荐', href: '#cards' },
        { label: '焦点专题', href: '#carousel' },
        { label: '下载APP', href: '#app' },
        { label: '常见问答', href: '#faq' },
      ],
    },
    {
      title: '内容分类',
      links: [
        { label: '韩漫', href: '#cards' },
        { label: '日漫', href: '#cards' },
        { label: '国漫', href: '#cards' },
        { label: '恋爱', href: '#index' },
        { label: '热血', href: '#index' },
        { label: '奇幻', href: '#index' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { label: '平台介绍', href: '#about' },
        { label: '联系我们', href: '#contact' },
        { label: '最新动态', href: '#updates' },
        { label: '视频专区', href: '#media' },
        { label: '专题索引', href: '#index' },
      ],
    },
  ],
};